/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/namespace */
import type CreateJS from '@suntex.classic/createjs';

import './createjs';

import * as utils from './index';

declare global {
  const cjs: typeof CreateJS;

  const ArrayUtil: typeof utils.ArrayUtil;
  const Calculator: typeof utils.Calculator;
  const Chance: typeof utils.Chance;
  const GraphicsUtil: typeof utils.GraphicsUtil;
  const LoadUtil: typeof utils.LoadUtil;
  const Meter: typeof utils.Meter;
  const TestUtil: typeof utils.TestUtil;
  const Timer: typeof utils.Timer;
  const UIUtil: typeof utils.UIUtil;

  const hostType: typeof utils.hostType;
  const isLocalHtmlFile: typeof utils.isLocalHtmlFile;
  const isCdnHtmlFile: typeof utils.isCdnHtmlFile;
  const isLocalHost: typeof utils.isLocalHost;
  const fimCdnUrl: typeof utils.fimCdnUrl;
  const parseBoolean: typeof utils.parseBoolean;
}

export function initGlobalLibraries() {
  for (const name of Object.keys(utils) as (keyof typeof utils)[]) {
    (globalThis as any)[name] = utils[name];
    (window as any)[name] = utils[name];
  }
}

initGlobalLibraries();
